import * as React from 'react';
import { useSelector } from 'react-redux';
import { erweiterteSuchenSelector } from 'store/lookups/selector';
import { requestErweiterteSuchen } from 'store/lookups/actions';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { DefaultButton, Dialog, DialogFooter, DialogType, Fabric, PrimaryButton } from '@fluentui/react';
import { viewStyles } from 'styles/viewStyles';
import { formStyles } from 'styles/formStyles';
import { FormTextField } from 'formComponents/FormTextField';
import { SavingState } from 'api/savingState';
import {
    addErweiterteSuche,
    defaultErweiterteSuche,
    ErweiterteSuche,
    updateErweiterteSuche,
} from 'api/erweiterteSuche';

const styles = mergeStyleSets({
    container: {
        position: 'relative',
        height: 'calc(100vh - 120px)',
        display: 'grid',
        gridTemplateRows: 'max-content 1fr',
        gridRowGap: 10,
    },
    searchBar: {
        display: 'grid',
        gridTemplateColumns: '1fr max-content',
        gridColumnGap: 10,
        marginTop: 10,
    },
});

export const ErweiterteSuchen: React.FC = () => {
    const erweiterteSuchen = useSelector(erweiterteSuchenSelector);

    const [editData, setEditData] = React.useState<ErweiterteSuche | null>(null);

    const save = async () => {
        if (!editData) {
            return;
        }
        if (editData?.nr === -1) {
            await addErweiterteSuche(editData);
        } else {
            await updateErweiterteSuche(editData);
        }
        await requestErweiterteSuchen();
        setEditData(null);
    };

    return (
        <Fabric className={styles.container}>
            <div className={styles.searchBar}>
                <div />

                <PrimaryButton onClick={() => setEditData({ ...defaultErweiterteSuche, nr: -1 })} text="Neu" />
            </div>
            <div className={viewStyles.listContainerScroll}>
                <table className={formStyles.lookupTable}>
                    <thead className={formStyles.lookupTableHead}>
                        <tr>
                            <td className={formStyles.lookupTableCell}>Text</td>
                            <td className={formStyles.lookupTableCell} />
                        </tr>
                    </thead>
                    <tbody className={formStyles.lookupTableBody}>
                        {erweiterteSuchen
                            .sort((a, b) => a.text.localeCompare(b.text))
                            .map((erweiterteSuche) => (
                                <tr key={erweiterteSuche.nr} className={formStyles.looupTableRow}>
                                    <td className={formStyles.lookupTableCell}>{erweiterteSuche.text}</td>
                                    <td className={formStyles.lookupTableActionCell}>
                                        <DefaultButton
                                            className={formStyles.lookupTableEditButton}
                                            onClick={() => setEditData({ ...erweiterteSuche })}
                                            text="Bearbeiten"
                                        />
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            {editData && (
                <Dialog
                    hidden={false}
                    minWidth={800}
                    dialogContentProps={{
                        title: 'Bearbeiten',
                        type: DialogType.normal,
                    }}
                >
                    <FormTextField
                        value={editData.text}
                        savingState={SavingState.notChanged}
                        options={{}}
                        onChange={(newValue): void => {
                            if (editData) {
                                setEditData({
                                    ...editData,
                                    text: newValue as string,
                                });
                            }
                        }}
                        label="Name"
                    />
                    <DialogFooter>
                        <DefaultButton onClick={() => setEditData(null)} text="Abbruch" />
                        <PrimaryButton onClick={save} text="Speichern" />
                    </DialogFooter>
                </Dialog>
            )}
        </Fabric>
    );
};
